import { store } from '../store/store';

/**
 * Returns boolean indicating if the current theme is dark or not
 */
export const getIsDarkTheme = (): boolean => store.isDarkTheme;
